export const StatCard = ({ label, value, icon: Icon, testId, delay = 0 }) => (
  <div className="fade-up bg-white border border-slate-200 rounded-xl p-5 flex items-start justify-between" style={{ animationDelay: `${delay}ms` }}>
    <div>
      <div className="small-label">{label}</div>
      <div className="font-heading text-3xl font-bold text-slate-900 mt-2" data-testid={testId}>{value}</div>
    </div>
    {Icon && <div className="h-10 w-10 rounded-lg bg-[#EFF6FF] text-[#2563EB] grid place-items-center"><Icon className="h-5 w-5" /></div>}
  </div>
);
